/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CompanyAliasPositionAliasIndexRouteImport } from './routes/$companyAlias/$positionAlias/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyAliasPositionAliasIndexRoute =
  CompanyAliasPositionAliasIndexRouteImport.update({
    id: '/$companyAlias/$positionAlias/',
    path: '/$companyAlias/$positionAlias/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$companyAlias/$positionAlias': typeof CompanyAliasPositionAliasIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$companyAlias/$positionAlias': typeof CompanyAliasPositionAliasIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$companyAlias/$positionAlias/': typeof CompanyAliasPositionAliasIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$companyAlias/$positionAlias'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$companyAlias/$positionAlias'
  id: '__root__' | '/' | '/$companyAlias/$positionAlias/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CompanyAliasPositionAliasIndexRoute: typeof CompanyAliasPositionAliasIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$companyAlias/$positionAlias/': {
      id: '/$companyAlias/$positionAlias/'
      path: '/$companyAlias/$positionAlias'
      fullPath: '/$companyAlias/$positionAlias'
      preLoaderRoute: typeof CompanyAliasPositionAliasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CompanyAliasPositionAliasIndexRoute: CompanyAliasPositionAliasIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
